<template>
    <div class="frame-content">
        <div class="layout-left" style="width:360px;">
            <div class="filter-tree">
                <el-input
                    placeholder="搜索"
                    v-model="filterTreeText"
                    size="small">
                </el-input>
            </div>
            <div class="left-box-wrap">
                <Scrollbar style="height:100%;">
                    <div class="left-box">
                        <el-tree 
                            ref="leftTree"
                            :expand-on-click-node="false"
                            :data="treeData" 
                            :filter-node-method="filterNode"
                            default-expand-all
                            node-key="id"
                            :props="{ children: 'children', label: 'name' }" 
                            @node-click="handleNodeClick">
                        </el-tree>
                    </div>
                </Scrollbar>
            </div>
        </div>
        <div class="frame-content-wrap layout-right" style="margin-left:360px;padding-left:30px;" v-if="nodeData.type && nodeData.type === 2">
            <h3>宣传片</h3>
            <div style="width:400px;margin-top:20px;">
                <el-upload
                class="upload-demo"
                drag
                :key="nodeId"
                :accept="'.mp4,.png,.jpg,.jpeg'"
                :action="action"
                :before-upload="beforeUpload"
                :on-exceed="handleExceed"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :file-list="fileList"
                :on-success="success"
                :limit="1">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将宣传片拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传mp4/png/jpg/jpeg文件，且不超过500M</div>
                </el-upload>
            </div>
            <el-button type="primary" :disabled="!videoUrl" :loading="saveLoading" style="margin-top:20px;" @click="save">保存</el-button>
        </div>
        <div class="frame-content-wrap layout-right" style="margin-left:360px;padding-left:30px;" v-else>
            <span>请选择目标项目，然后再上传宣传片</span>
        </div>
    </div>
</template>

<script>
import common from '@/utils/common'
import http from '@/utils/http'
import Scrollbar from '@/components/Scrollbar'

export default {
    name: 'SystemSet',
    components: {
        Scrollbar,
    },
    data() {
        return {
            action:process.env.VUE_APP_BASE_URL + '/v1/oss/upload',
            treeData: [],

            nodeId: '',
            nodeData: {},
            filterTreeText: '',
            videoUrl:'',
            fileList:[],
            saveLoading:false
        };
    },
    created () {
        this.loadTree();
    },
    watch: {
        filterTreeText(val) {
            this.$refs.leftTree.filter(val);
        },
        ['dateRange'] (val) {
            if (!val || val.length < 1) {
                this.filters.startTime = '';
                this.filters.endTime = '';
                return;
            }
            this.filters.startTime = val[0];
            this.filters.endTime = val[1];
        }
    },
    methods: {
        ...common,
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        loadTree() {
            let params = { tenantId: 1 };

            http.get('v1/org/orgTree', {
                params: params
            }).then(req => {
                if (this.httpThen(req)) {
                    return;
                }
                if (req.data.code == http.SUCCESS) {
                    this.treeData = req.data.data;
                    this.$nextTick(() => {
                        if (this.treeData && this.treeData.length > 0 && this.$refs.leftTree) {
                            if (this.nodeId != '') {
                                let node = this.$refs.leftTree.getNode(this.nodeId);
                                if (!node) {
                                    this.nodeId = this.treeData[0].id;
                                    this.nodeData = this.treeData[0];
                                }
                            } else {
                                this.nodeId = this.treeData[0].id;
                                this.nodeData = this.treeData[0];
                            }
                            
                            this.$refs.leftTree.setCurrentKey(this.nodeId);

                            this.loadTable();
                        }
                    });
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.httpCatch(err);
            });
        },
        loadTable() {
            this.tableLoading = true;
            http.post('v1/bi/biSetting/query', {
                projectId: this.nodeId
            }).then(res => {
                console.log(res,'9990')
                this.tableLoading = false;
                if(res.data?.data?.publicityUrl){
                    this.videoUrl = res.data?.data?.publicityUrl
                    this.fileList = [
                        {
                            url: res.data?.data?.publicityUrl,
                            name: res.data?.data?.publicityUrl.substring(res.data?.data?.publicityUrl.lastIndexOf('/') + 1)
                        }
                    ]
                }else{
                    this.fileList = []
                    this.videoUrl = ''
                }
            }).catch(err => {
                console.log(err);
                this.tableLoading = false;
            });
        },
        // handleNodeClick(data, node, vuecomponent) {
        handleNodeClick(data) {
            console.log(data);
            this.nodeId = data.id;
            this.nodeData = data;
            this.loadTable();
        },
        success(response, file, fileList){
            console.log('999',response, file, fileList);
            if(response.code === 0){
                this.videoUrl = response.data.url
                // `${process.env.VUE_APP_BASE_URL}${response.data.url}`;  
            }
        },
        beforeRemove(){

        },
        beforeUpload(file){
            console.log(file,'3333');
            return new Promise((resolve, reject) => {
                const types = ['mp4', 'png', 'jpeg', 'jpg'];
                const type = file.type.split('/')[1];
                if(!types.includes(type.toLowerCase())){
                    this.showError('文件格式错误，请上传视频活图片类型,如：mp4，png，jpeg，jpg后缀的文件。');
                    reject();
                }
                //516081102
                if(file.size > 1024 * 1024 * 500){
                    this.showError('文件大小不能超过500M');
                    reject();
                }
                resolve();
            });
        },
        handleRemove(){
            this.videoUrl = '';
        },
        handleExceed(files, fileList) {
            console.log(files, fileList);
            this.showError(`当前限制选择 1 个文件，请删除当前文件后重新上传。`);
        },
        save(){
            this.saveLoading = true;
            http.post('v1/bi/biSetting/save', {
                projectId: this.nodeId,
                publicityUrl: this.videoUrl
            }).then(res => {
                console.log(res)
                this.saveLoading = false;
                if(res.data?.code === 0){
                    this.showSuccess('保存成功');
                }
            }).catch(err => {
                console.log(err);
                this.showError(err || err.msg);
                this.saveLoading = false;
            });
        },

    }
}
</script>

<style scoped>
</style>